import { Injectable } from '@angular/core';
import { InsertUserMutationResponse } from 'src/app/shared/models/graphql';
import { UserData } from 'src/app/shared/models/interfaces/user-data';

@Injectable({
  providedIn: 'root'
})



export class UserService {


  public userData: UserData;
  public userDataTemp: UserData;
  public isVerified: boolean = false;

  constructor() { 

    let storgeUser = this.userData = JSON.parse(localStorage.getItem("userData"));
    if (storgeUser) {
      this.userData = storgeUser;
    } else {
      this.userData = {};      
    }

    let storgeUserTemp = this.userDataTemp = JSON.parse(localStorage.getItem("userDataTemp"));
    if (storgeUserTemp) {
      this.userDataTemp = storgeUserTemp;
    } else {
      this.userDataTemp = {};      
    }

  }


  /**
   * add user data
   * @param userData 
  */ 
  addUserData(userData){
    this.userData = userData
    this.saveUser();
  }

  addUserDataTemp(userData){
    this.userDataTemp = userData
    this.saveUserTemp();
  }

  /**
   * add user data
   * @param mobileNumber 
  */ 
  addUserMobileNumber(mobileNumber: string) {
    this.userData.mobile = mobileNumber.toString()
    this.saveUser();
  }


  //get user mobile number
  get userMobileNumber() {
    return this.userData.mobile;
  }


  // save user data in localStorage
  private saveUser() {
    localStorage.setItem("userData", JSON.stringify(this.userData))
  }

  private saveUserTemp() {
    localStorage.setItem("userDataTemp", JSON.stringify(this.userDataTemp))
  }


}
